import { string, isnil, array, required } from 'vue-mc/validation'
import BaseModel from '@/models/BaseModel'

export default class Prospection extends BaseModel {
  defaults () {
    return {
      recipes: [],
      orders: [],
      area: null,
      author: null,
      status: 'initialized'
    }
  }

  options () {
    return {
      methods: {
        create: 'POST',
        clear: 'POST'
      }
    }
  }

  getDefaultMethods () {
    return {
      fetch: 'GET',
      save: 'POST',
      update: 'PUT',
      create: 'POST',
      patch: 'PUT',
      delete: 'POST'
    }
  }

  validation () {
    return {
      recipes: [isnil.or(array)],
      orders: [isnil.or(array)],
      area: [string.and(required)],
      author: [string],
      status: [string]
    }
  }

  shouldPatch () {
    return true
  }

  create () {
    const method = this.getOption('methods.create')
    const route = this.getRoute('create')
    const params = this.getRouteParameters()
    const headers = this.getDefaultHeaders()
    const url = this.getURL(route, params)
    const data = {
      area: this.area,
      recipes: this.recipes
    }

    return this.createRequest({ method, url, headers, data }).send()
  }

  clear () {
    const method = this.getOption('methods.clear')
    const route = this.getRoute('clear')
    const params = this.getRouteParameters()
    const headers = this.getDefaultHeaders()
    const url = this.getURL(route, params)

    return this.createRequest({ method, url, headers }).send()
  }

  routes () {
    return {
      create: `${this.API_BASE}/v1/prospections`,
      clear: `${this.API_BASE}/v1/prospections/{id}/clear`
    }
  }
}
